import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Input,
  Optional,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { IconComponent } from '@examdojo/core/icon';
import { ComponentSize, DEFAULT_COMPONENT_SIZE } from '@examdojo/core/model';
import { InputFocusService } from '@examdojo/ui/focus';
import { UntilDestroy } from '@ngneat/until-destroy';
import { take, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'dojo-list-view-search-field',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, IconComponent],
  templateUrl: './list-view-search-field.component.html',
  styleUrls: ['./list-view-search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewSearchFieldComponent implements AfterViewInit {
  constructor(
    private readonly destroyRef: DestroyRef,
    @Optional() private readonly inputFocusService?: InputFocusService,
  ) {}

  @Input() searchLabel = '';
  @Input() searchPlaceholder = '';
  @Input() searchCtrl!: FormControl<string | null>;
  @Input() searchFieldClasses!: string;
  @Input() compact?: boolean | null;
  @Input() sizeSearchFiled: ComponentSize = DEFAULT_COMPONENT_SIZE;

  @ViewChild(MatInput, { static: true }) input?: MatInput;

  ngAfterViewInit() {
    this.inputFocusService?.focusTrigger$
      .pipe(
        tap(() => this.input?.focus()),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
